"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const PageWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 60px);
  padding: 16px;
  text-align: center;
  background: #fff;
`;
const BookingLinkoutSuccess = ({ currentLocale, userData }) => {
    const [successHtml, setSuccessHtml] = (0, react_1.useState)('');
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const handleSuccessContainerClick = (event) => {
        var _a;
        const target = event.target;
        const anchor = (_a = target === null || target === void 0 ? void 0 : target.closest) === null || _a === void 0 ? void 0 : _a.call(target, 'a');
        if (!(anchor === null || anchor === void 0 ? void 0 : anchor.href)) {
            return;
        }
        event.preventDefault();
        window.top.location.href = anchor.href;
    };
    (0, react_1.useEffect)(() => {
        const params = new URLSearchParams(window.location.search);
        const sourceReturnUrl = params.get('sourceReturnUrl');
        let availabilityId = params.get('availabilityId');
        if (!availabilityId && sourceReturnUrl) {
            try {
                const sourceReturnParams = new URL(sourceReturnUrl).searchParams;
                availabilityId = sourceReturnParams.get('availabilityId');
            }
            catch (_) {
                availabilityId = null;
            }
        }
        if (!availabilityId || !(userData === null || userData === void 0 ? void 0 : userData.token)) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        services_1.apiService
            .getExternalLinkOutConfirmation(currentLocale, userData.token, availabilityId)
            .then((response) => {
            var _a, _b;
            if ((response === null || response === void 0 ? void 0 : response.status) === 'success') {
                setSuccessHtml(((_b = (_a = response === null || response === void 0 ? void 0 : response.confirmation) === null || _a === void 0 ? void 0 : _a.texts) === null || _b === void 0 ? void 0 : _b.text) || '');
            }
        })
            .catch(() => {
            setSuccessHtml('');
        })
            .finally(() => {
            setIsLoading(false);
        });
    }, [currentLocale, userData]);
    if (isLoading) {
        return (react_1.default.createElement(PageWrapper, null,
            react_1.default.createElement(Loader_1.default, null)));
    }
    return (react_1.default.createElement(PageWrapper, null, successHtml ? (react_1.default.createElement("div", { onClick: handleSuccessContainerClick, dangerouslySetInnerHTML: { __html: successHtml } })) : null));
};
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(BookingLinkoutSuccess);
